/* src/app/landingpages/elevplus-classes/elevplus-classes.component.css */
.spacer {
  height: 50px;
}
.elev-hero {
  display: flex;
  align-items: center;
  background-image: url(/assets/images/elev-p.png);
  background-size: cover;
  background-position: center;
}
.hero-content {
  margin-top: 150px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 50px;
}
.hero-right {
  width: 60%;
  display: flex;
  flex-direction: column;
  margin-left: 25px;
  padding: 25px;
  color: white;
}
.elev-hero h1 {
  font-size: 60px;
  margin-bottom: 20px;
  color: white;
  font-weight: 600;
}
.elev-hero h3 {
  font-size: 24px;
  color: white;
  margin-bottom: 20px;
  font-weight: 600;
}
.hero-right button {
  width: 300px;
  background-color: #007BA7;
  color: #ffffff;
  border: none;
  padding: 12px 24px;
  font-size: 18px;
  cursor: pointer;
  border-radius: 35px;
  transition: background-color 0.3s ease;
  font-weight: 600;
}
.hero-right button:hover {
  background-color: #005f7f;
}
.hero-left {
  width: 40%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.hero-ft {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 35px;
  margin: 50px;
}
.hero-card {
  width: 300px;
  display: flex;
  background-color: white;
  border-radius: 20px;
  transition: .3s ease;
}
.hero-card h4 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}
.hero-card img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 15px;
  margin: 10px;
}
.hero-card button {
  padding: 5px 10px;
  border: none;
  border-radius: 20px;
  background-color: #007BA7;
  color: white;
}
.hero-card div {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 10px;
}
.hero-card:hover {
  transform: translateY(-25%);
  box-shadow: rgba(226, 196, 63, 0.25) 0px 13px 47px -5px, rgba(180, 71, 71, 0.3) 0px 8px 16px -8px;
}
.testmonials {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.testmonials h1 {
  font-size: 40px;
  font-weight: 550;
  margin: 0px;
  color: #007BA7;
  text-align: center;
}
.sec-4 {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.sec-4 h2 {
  font-size: 36px;
  font-weight: 500;
  margin: 0px;
}
.cs-sec {
  display: flex;
  gap: 100px;
  margin-top: 50px;
}
.cs-crd {
  display: flex;
  padding: 20px;
  width: 380px;
  gap: 5px;
  border-radius: 15px;
  background-color: #F7F7F7;
}
.cs-sec iframe {
  width: 350px;
  height: 200px;
}
.strip {
  width: 100%;
  background-color: #F5AF12;
  margin: 50px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 200px;
  padding: 20px;
}
.strip h1 {
  font-size: 36px;
  font-weight: 550;
  color: #030303;
}
.cta-1 {
  width: 300px;
  background-color: #007BA7;
  color: #ffffff;
  border: none;
  padding: 12px 24px;
  font-size: 18px;
  cursor: pointer;
  border-radius: 35px;
  transition: background-color 0.3s ease;
  font-weight: 600;
}
.cta-1:hover {
  background-color: #005f7f;
}
.strategy {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.strategy h1 {
  font-size: 40px;
  font-weight: 550;
  color: #005f7f;
  text-align: center;
}
.strategy h3 {
  font-size: 24px;
  font-weight: 500;
  color: #020202;
}
:host {
  --card-w: 280px;
  --gap: 24px;
}
.slider {
  position: relative;
  width: 90%;
  margin: 0 auto;
  padding: 12px 0 28px;
}
.viewport {
  display: flex;
  gap: var(--gap);
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  padding: 4px 8px 18px;
  -webkit-overflow-scrolling: touch;
  touch-action: pan-x;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.viewport::-webkit-scrollbar {
  display: none;
}
.viewport {
  cursor: grab;
}
.viewport.dragging,
.viewport:active {
  cursor: grabbing;
}
.card {
  position: relative;
  flex: 0 0 var(--card-w);
  height: 340px;
  background: #fff;
  border-radius: 22px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, .1);
  overflow: hidden;
  display: grid;
  grid-template-rows: auto 1fr;
  isolation: isolate;
  cursor: pointer;
}
.snap {
  scroll-snap-align: start;
}
.text .title {
  font-weight: 600;
  font-size: 26px;
  color: #111827;
  line-height: 10px;
}
.text .subtitle {
  font-size: 18px;
  color: #6b7280;
  font-weight: 600;
}
.desc {
  list-style: disc;
  padding-left: 20px;
}
.text .hover-chip {
  position: absolute;
  top: 1.6rem;
  left: 0;
  font-size: .72rem;
  color: #6b7280;
  opacity: 0;
  transform: translateY(-4px);
  transition: opacity .25s ease, transform .25s ease;
  pointer-events: none;
}
.card:hover .hover-chip {
  opacity: 1;
  transform: translateY(0);
}
.thumb {
  align-self: end;
  justify-self: end;
}
.thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.card .overlay {
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: 12px;
  padding: 14px 16px;
  background: rgba(17, 17, 17, 0.72);
  color: #fff;
  border-radius: 16px;
  transform: translateY(110%);
  opacity: 0;
  transition: transform .28s ease, opacity .28s ease;
  will-change: transform, opacity;
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
}
.card:hover .overlay,
.card .overlay.show {
  transform: translateY(0);
  opacity: 1;
}
.card .overlay p {
  margin: 0;
  line-height: 1.4;
  pointer-events: none;
}
.dots {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 12px;
}
.dots button {
  width: 10px;
  height: 10px;
  border-radius: 999px;
  border: none;
  background: #d1d5db;
  cursor: pointer;
  transition: transform .2s ease, background .2s ease;
}
.dots button.active {
  background: #0ea5e9;
  transform: scale(1.15);
}
.nav {
  position: absolute;
  top: 40%;
  width: 34px;
  height: 34px;
  border-radius: 999px;
  border: none;
  background: #fff;
  box-shadow: 0 6px 18px rgba(0, 0, 0, .12);
  cursor: pointer;
  z-index: 3;
}
.nav.prev {
  left: -14px;
}
.nav.next {
  right: -14px;
}
.nav::before {
  content: "";
  display: block;
  width: 8px;
  height: 8px;
  border-right: 2px solid #111827;
  border-bottom: 2px solid #111827;
  transform: rotate(-45deg);
  margin: 12px auto;
}
.nav.next::before {
  transform: rotate(135deg);
}
@media (max-width: 980px) {
  :host {
    --card-w: 240px;
  }
}
@media (max-width: 640px) {
  :host {
    --card-w: 86vw;
  }
}
.subjects {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.subjects h1 {
  font-size: 40px;
  font-weight: 550;
  color: #005f7f;
  margin-bottom: 25px;
  text-align: center;
}
.subject-list {
  display: flex;
  align-items: center;
  list-style: disc;
  gap: 30px;
}
.u {
  gap: 65px;
}
.subject-list li {
  font-size: 20px;
  font-weight: 500;
  color: #333;
  padding: 8px 0;
}
.course-container {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  gap: 50px;
  flex-wrap: wrap;
  justify-content: center;
}
.course-card {
  background: white;
  border-radius: 15px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  width: 400px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.course-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}
.card-header {
  padding: 25px 25px 20px;
  color: white;
  font-weight: bold;
}
.orange-gradient {
  background: #007BA7;
}
.card-title {
  font-size: 20px;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.title-icon {
  font-size: 18px;
}
.card-subtitle {
  font-size: 14px;
  font-weight: normal;
  line-height: 1.4;
}
.card-content {
  padding: 25px;
  background: white;
}
.info-section {
  margin-bottom: 20px;
}
.section-label {
  font-weight: bold;
  color: #333;
  font-size: 14px;
  margin-bottom: 5px;
}
.section-text {
  color: #666;
  font-size: 14px;
  line-height: 1.4;
}
.feature-list {
  list-style: none;
  padding-left: 0;
}
.feature-list li {
  position: relative;
  padding-left: 15px;
  margin-bottom: 3px;
  color: #666;
  font-size: 14px;
  line-height: 1.4;
}
.feature-list li::before {
  content: "\2022";
  position: absolute;
  left: 0;
  color: #f39c12;
  font-weight: bold;
}
.demo-btn {
  width: 100%;
  background:
    linear-gradient(
      135deg,
      #3498db,
      #2980b9);
  color: white;
  border: none;
  padding: 15px 20px;
  border-radius: 25px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 10px;
}
.demo-btn:hover {
  background:
    linear-gradient(
      135deg,
      #2980b9,
      #21618c);
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(52, 152, 219, 0.3);
}
.rar {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.rar h1 {
  font-size: 40px;
  font-weight: 550;
  color: #005f7f;
  margin-bottom: 10px;
  text-align: center;
}
.rar h3 {
  font-size: 20px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-bottom: 25px;
  text-align: center;
}
.section-6 {
  margin-top: 50px;
  background-color: #ffffff;
  padding: 50px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.section-6 h1 {
  font-size: 40px;
  font-weight: 550;
  text-align: center;
}
.gallery-container {
  display: flex;
  width: 100%;
  padding: 20px;
}
.gal-left {
  width: 50%;
  padding: 20px;
}
.gal-left img {
  border-radius: 20px;
  width: 100%;
  height: 600px;
  object-fit: cover;
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
}
.large-image.zoom {
  transform: scale(1.1);
  opacity: 0.7;
}
.gal-right {
  width: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.gal-right h1 {
  font-size: 40px;
  font-weight: 500;
  margin-top: auto;
  margin-bottom: 50px;
  transition: opacity 0.3s ease-in-out;
}
.btn-div {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 25px;
}
.gal-btn {
  padding: 15px 30px;
  border: none;
  border-radius: 30px;
  background-color: #007ba7;
  margin-bottom: 150px;
  color: white;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
  transition: background-color 0.3s ease-in-out;
}
.sd {
  background-color: #ffbf00;
}
.gal-btn:hover {
  background-color: #ED6823;
}
.sd:hover {
  background-color: #ffffff;
  color: #ED6823;
}
.gal-thumb {
  width: 100%;
  display: flex;
  gap: 20px;
  margin: 20px;
}
.gal-thumb img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 20px;
  margin-top: auto;
  transition: transform 0.3s ease-in-out, border 0.3s ease-in-out;
}
.gal-thumb img:hover,
.gal-thumb img.active {
  transform: scale(1.2);
  border: 3px solid orange;
}
@media (max-width: 768px) {
  .hero-content {
    flex-direction: column;
    margin-top: 50px;
    padding: 20px;
  }
  .hero-right,
  .hero-left {
    width: 100%;
    margin: 0;
    padding: 15px;
  }
  .hero-left {
    display: none;
  }
  .elev-hero h1 {
    font-size: 36px;
  }
  .elev-hero h3 {
    font-size: 18px;
  }
  .hero-right button {
    width: 100%;
    max-width: 300px;
  }
  .hero-card {
    width: 100%;
    max-width: 350px;
  }
  .cs-sec {
    flex-direction: column;
    gap: 30px;
    align-items: center;
  }
  .cs-sec iframe {
    width: 100%;
    max-width: 350px;
    height: 200px;
  }
  .strip {
    flex-direction: column;
    gap: 30px;
    padding: 30px 20px;
  }
  .strip h1 {
    font-size: 24px;
    text-align: center;
  }
  .cta-1 {
    width: 100%;
    max-width: 300px;
  }
  .strategy h1 {
    font-size: 32px;
  }
  .strategy h3 {
    font-size: 20px;
    text-align: center;
    padding: 0 20px;
  }
  :host {
    --card-w: 90vw;
  }
  .subjects h1 {
    font-size: 32px;
  }
  .subject-list {
    flex-direction: column;
    gap: 10px;
    width: 100%;
    padding: 0 20px;
  }
  .u {
    gap: 20px;
  }
  .course-container {
    flex-direction: column;
    align-items: center;
    gap: 30px;
  }
  .course-card {
    width: 100%;
    max-width: 350px;
  }
  .rar h1 {
    font-size: 32px;
  }
  .rar h3 {
    font-size: 18px;
    padding: 0 20px;
  }
  .rar img {
    width: 100%;
    max-width: 350px;
  }
  .gallery-container {
    flex-direction: column;
  }
  .gal-left,
  .gal-right {
    width: 100%;
    padding: 10px;
  }
  .gal-left img {
    height: 300px;
  }
  .gal-right h1 {
    font-size: 28px;
    margin-bottom: 20px;
  }
  .gal-thumb {
    flex-wrap: wrap;
    justify-content: center;
  }
  .gal-thumb img {
    width: 70px;
    height: 70px;
  }
  .spacer {
    height: 30px;
  }
}
/*# sourceMappingURL=elevplus-classes.component.css.map */
